module.exports = __webpack_public_path__ + "img/weapon12.png";